import { useState } from "react";
import CTASection from "../components/CTASection";
import MilletModal from "../components/MilletModal";
import { MILLETS, BENEFITS } from "../data/data";

function MilletCategory({ label, items, onSelect }) {
  return (
    <div className="millet-cat">
      <div className="cat-header">
        <div className="cat-badge">{label}</div>
        <div className="cat-line" />
      </div>
      <div className="millet-grid">
        {items.map((m, i) => (
          <div className="millet-card" key={i} onClick={() => onSelect(m)}>
            <img src={m.img} alt={m.name} className="millet-img" onError={e => { e.target.style.display = "none"; }}  loading="lazy" />
            <div className="millet-name">{m.name}</div>
            <div className="millet-hindi">{m.hindi}</div>
            {m.sci && <div className="millet-sci">{m.sci}</div>}
            <p className="millet-desc">{m.desc}</p>
            <div className="millet-card-hint">Click to learn more →</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function MilletsPage({ setPage }) {
  const [modal, setModal] = useState(null);

  return (
    <>
      <div className="page-banner" style={{ background: "linear-gradient(135deg,#1a3a1a 0%,#2d5a1b 100%)" }}>
        <div>
          <h1>Our <span>Millet</span> Selection</h1>
          <p>Each millet brings unique health benefits and incredible flavours — discover the ancient supergrains inside every momo.</p>
        </div>
      </div>

      <section className="millets-section">
        <div className="sec-header">
          <h2 className="sec-title">10+ Varieties of Ancient Grains</h2>
          <p className="sec-sub">Click any millet card to learn more about its health benefits and nutritional profile</p>
        </div>
        <div className="millets-wrap">
          <MilletCategory label="Major Millets"   items={MILLETS.major}  onSelect={setModal} />
          <MilletCategory label="Minor Millets"   items={MILLETS.minor}  onSelect={setModal} />
          <MilletCategory label="Pseudo-Millets"  items={MILLETS.pseudo} onSelect={setModal} />

          {/* Benefits table */}
          <div className="benefits-box">
            <div className="benefits-hd"><h3>Quick Millet Benefits</h3></div>
            <div className="benefits-grid">
              {BENEFITS.map((b, i) => (
                <div className="benefit-item" key={i}>
                  <div className="b-image"><img src={b.img} alt={b.millet} className=""  loading="lazy" /></div>
                  <div className="b-millet">{b.millet}</div>
                  <div className="b-arrow">→</div>
                  <div className="b-val">{b.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CTASection setPage={setPage} />

      {modal && <MilletModal millet={modal} onClose={() => setModal(null)} />}


    </>
  );
}